import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class MwTunnelGrid extends Component {
  @service dynamicDialogs;

  @tracked scrollValue;
  @tracked didInsert = false;

  constructor() {
    super(...arguments);
    this.scrollValue = Math.max(0, window.scrollY);
    this.setupScrollListener();
  }

  @action
  onInsert() {
    this.didInsert = true;
  }

  get floorStyle() {
    return `
      background-position-y: -${this.scrollValue}px;
    `;
  }

  get ceilingStyle() {
    return `
      background-position-y: -${this.scrollValue}px;
    `;
  }

  get leftStyle() {
    return `
      background-position-x: -${this.scrollValue}px;
    `;
  }

  get rightStyle() {
    return `
      background-position-x: -${this.scrollValue}px;
    `;
  }

  @action
  setupScrollListener() {
    let lastCall = 0;
    this.handleScroll = () => {
      const now = Date.now();
      if (now - lastCall >= 10) {
        this.scrollValue = window.scrollY / 15;
        lastCall = now;
      }
    };

    window.addEventListener('scroll', this.handleScroll);
  }

  willDestroy() {
    super.willDestroy();
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
}